import { IWarehouseRawMaterial } from "./warehouseRawMaterial.model";

export const getStatusColor = (status: FloorRequestStatus): string => {
  switch (status) {
    case "pending":
      return "bg-amber-100/80 text-amber-900 border-amber-300";
    case "approved":
      return "bg-blue-100/80 text-blue-900 border-blue-300";
    case "partially fulfilled":
      return "bg-cyan-100/80 text-cyan-900 border-cyan-300";
    case "fulfilled":
      return "bg-emerald-100/80 text-emerald-900 border-emerald-300";
    case "rejected":
      return "bg-rose-100/80 text-rose-900 border-rose-300";
    case "cancelled":
      return "bg-slate-100 text-slate-700 border-slate-300";
    case "removed":
      return "bg-zinc-100 text-zinc-600 border-zinc-300";
    default:
      return "bg-gray-100 text-gray-800 border-gray-300";
  }
};
export type FloorRequestStatus =
  | "pending"
  | "approved"
  | "partially fulfilled"
  | "fulfilled"
  | "rejected"
  | "cancelled"
  | "removed";

export type FloorBatchStatus =
  | "working"
  | "waiting for items"
  | "sent to store"
  | "cancelled";

export interface IFloorRequest {
  _id: string;
  batchNo?: number;
  batchCreatedDate?: Date;
  batchStatus?: FloorBatchStatus;
  requestNo: number;
  type: "product" | "material";
  items?: number;
  warehouseId: {
    _id: string;
    name: string;
  };
  requestedBy: { _id: string; username: string };
  remark?: string;
  status: FloorRequestStatus;
  createdAt: Date;
  updatedAt: Date;
  userDetails?: { username: string };
  warehouseDetails?: { name: string };
  rawMaterialId?: { name: string; _id: string };
  productid?: { productName: string; _id: string };
  rawMaterialQuantity?: number;
  productQuantity?: number;
  producedQuanitity?: number;
}
export interface IItemHistory {
  status: FloorRequestStatus;
  userId: { _id: string; username: string };
  remark?: string;
  date: Date;
}

export interface IFloorRequestItem {
  _id: string;
  requestId: string;
  rawMaterialId: IWarehouseRawMaterial;
  requestedQuantity: number;
  approvedQuantity: number;
  fulfilledQuantity: number;
  unit: string;
  status: FloorRequestStatus;
  history: IItemHistory[];
}
